import { NumberInput } from '@mantine/core';
import { useTicketSalesSellableStore } from '../../../useTicketSalesSellable';

type TicketSalesSellableCellPropsType = {
  ticketSalesId: string;
  ticketsSellable: number;
  onUpdateSellable: (ticketSalesId: string, ticketsSellable: number) => void;
};

export const TicketSalesSellableCell: React.FC<
  TicketSalesSellableCellPropsType
> = ({ ticketSalesId, ticketsSellable, onUpdateSellable }) => {
  const sellable = useTicketSalesSellableStore(
    (state) => state.sellable[ticketSalesId] ?? ticketsSellable
  );
  const setSellable = useTicketSalesSellableStore((state) => state.setSellable);

  const handleChange = (nextValue: string | number) => {
    if (typeof nextValue !== 'number') return;

    setSellable(ticketSalesId, nextValue);
    onUpdateSellable(ticketSalesId, nextValue);
  };

  return (
    <NumberInput
      value={sellable}
      onChange={handleChange}
      hideControls
      allowDecimal={false}
      thousandSeparator="."
      decimalSeparator=","
    />
  );
};
